<header
  class="sticky top-0 z-[999] w-full backdrop-blur-lg bg-white/95 border-b border-gray-200 dark:bg-gray-900/95 dark:border-gray-700 shadow-sm"
>
  <!-- Desktop Layout -->
  <div class="hidden md:flex items-center justify-between h-20 px-6">
    <!-- Left Section: Logo -->
    <div class="flex items-center gap-3">
      <img [src]="environment.assetsPrefix + '/images/Final Logo No Tagline OL.png'" alt="Agency AKA" class="h-8 w-auto"/>
      <div class="hidden lg:block">
        <h1 class="text-lg font-bold text-gray-900 dark:text-white tracking-tight">Agency AKA</h1>
        <p class="text-xs text-gray-500 dark:text-gray-400 -mt-0.5">CRM Platform</p>
      </div>
    </div>

    <!-- Center Section: Search Bar -->
    <div class="flex-1 max-w-2xl mx-8">
      <div class="relative">
        <div class="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
          <lucide-icon [name]="SearchIcon" size="18" class="text-gray-400 dark:text-gray-500"></lucide-icon>
        </div>
        <input
          type="text"
          [(ngModel)]="searchQuery"
          (keydown)="onSearchKeydown($event)"
          placeholder="Search contacts, companies, events..."
          class="w-full pl-12 pr-4 py-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl text-gray-900 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-400 focus:ring-2 focus:ring-brand-500 dark:focus:ring-brand-400 focus:border-transparent transition-all duration-200 text-sm font-medium"
        />
      </div>
    </div>

    <!-- Right Section: User Menu -->
    <div class="flex items-center">
      <div class="relative">
        <button
          class="flex items-center gap-3 px-3 py-2 rounded-xl text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-all duration-200"
          (click)="dropdownOpen = !dropdownOpen"
        >
          <div class="w-9 h-9 rounded-xl bg-gradient-to-br from-brand-500 to-brand-600 flex items-center justify-center text-white text-sm font-semibold shadow-md">
            {{ user?.name?.charAt(0)?.toUpperCase() || 'U' }}
          </div>

          <div class="hidden lg:block text-left">
            <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ user?.name }}</div>
            <div class="text-xs text-gray-500 dark:text-gray-400 -mt-0.5">{{ user?.email }}</div>
          </div>

          <lucide-icon
            [name]="dropdownOpen ? ChevronUpIcon : ChevronDownIcon"
            size="16"
            class="text-gray-400 dark:text-gray-500 hidden lg:block"
          ></lucide-icon>
        </button>

        @if (dropdownOpen) {
          <div class="absolute right-0 mt-2 w-72 bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-xl overflow-hidden">
            <div class="p-4 border-b border-gray-100 dark:border-gray-700">
              <div class="flex items-center gap-3">
                <div class="w-12 h-12 rounded-xl bg-gradient-to-br from-brand-500 to-brand-600 flex items-center justify-center text-white font-semibold shadow-md">
                  {{ user?.name?.charAt(0)?.toUpperCase() || 'U' }}
                </div>
                <div>
                  <div class="text-sm font-semibold text-gray-900 dark:text-gray-100">{{ user?.name }}</div>
                  <div class="text-xs text-gray-500 dark:text-gray-400">{{ user?.email }}</div>
                </div>
              </div>
            </div>

            <div class="p-2">
              <button
                (click)="logout()"
                class="w-full flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-all duration-200"
              >
                <lucide-icon [name]="LogOutIcon" size="16"></lucide-icon>
                Sign out
              </button>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Mobile Layout -->
  <div class="md:hidden flex items-center justify-between h-16 px-4">
    <!-- Mobile Logo -->
    <div class="flex items-center gap-3">
      <img [src]="environment.assetsPrefix + '/images/Final Logo No Tagline OL.png'" alt="Agency AKA" class="h-7 w-auto"/>
      <h1 class="text-lg font-bold text-gray-900 dark:text-white tracking-tight">AKA</h1>
    </div>

    <!-- Mobile Search & User -->
    <div class="flex items-center gap-3">
      <!-- Mobile Search Icon (could trigger modal) -->
      <button class="p-2 text-gray-500 dark:text-gray-400 hover:text-brand-500 dark:hover:text-brand-400 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition-all duration-200">
        <lucide-icon [name]="SearchIcon" size="20"></lucide-icon>
      </button>

      <!-- Mobile User Avatar -->
      <button
        class="w-8 h-8 rounded-lg bg-gradient-to-br from-brand-500 to-brand-600 flex items-center justify-center text-white text-sm font-semibold shadow-md"
        (click)="dropdownOpen = !dropdownOpen"
      >
        {{ user?.name?.charAt(0)?.toUpperCase() || 'U' }}
      </button>
    </div>
  </div>
</header>
